/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseLangListItemViewModel } from "../types/CourseLangListItemViewModel.ts";

export const courseLangListItemViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID do registro de idioma do curso."),
  ),
  courseId: z.optional(z.number().int().describe("ID do curso.")),
  cultureInfo: z.string().describe("Cultura do registro.").nullish(),
  cultureName: z
    .string()
    .describe(
      "Nome do idioma no idioma padrão do sistema. Vazio quando a cultura não é uma das principais do LMS.",
    )
    .nullish(),
  nameOfficial: z
    .string()
    .describe("Nome oficial do curso neste idioma.")
    .nullish(),
  nameCommercial: z
    .string()
    .describe("Nome comercial do curso neste idioma.")
    .nullish(),
  description: z
    .string()
    .describe("Descrição do curso neste idioma. Opcional.")
    .nullish(),
  hasContentHtml: z.optional(
    z
      .boolean()
      .describe("Indica se o regimento em HTML está preenchido neste idioma."),
  ),
  hasContractBody: z.optional(
    z
      .boolean()
      .describe("Indica se o corpo do contrato está preenchido neste idioma."),
  ),
  hasSyllabus: z.optional(
    z.boolean().describe("Indica se a ementa está preenchida neste idioma."),
  ),
  hasManualFile: z.optional(
    z
      .boolean()
      .describe("Indica se existe PDF de manual anexado neste idioma."),
  ),
  hasRegimentFile: z.optional(
    z
      .boolean()
      .describe("Indica se existe PDF de regimento anexado neste idioma."),
  ),
  hasUspDocumentFile: z.optional(
    z
      .boolean()
      .describe(
        "Indica se existe PDF de carteirinha USP anexado neste idioma.",
      ),
  ),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração. Opcional.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração. Opcional.")
    .nullish(),
}) as unknown as ToZod<CourseLangListItemViewModel>;
